//机构类型 0-一般企业 1-政府机关 2-个体工商户 3-事业单位 4-社会团体 5-其他机构

import { getRuleLen } from '../../../utils/rules';

export const OrgKs = {
  creditCode: 'creditCode',
  registeredCapital: 'registeredCapital',
  registerDate: 'registerDate',
  legalPerson: 'legalPerson',
  lastYearTaking: 'lastYearTaking',
  location: 'location',
  isMerge: 'isMerge',
  mainBusiness: 'mainBusiness',
  businessScope: 'businessScope',
  organizationAbstract: 'organizationAbstract',
  qualificationCertificate: 'qualificationCertificate',
};
// 机构需要填的信息
// https://km.sankuai.com/preview?downloadURL=https%3A%2F%2Fkm.sankuai.com%2Fapi%2Ffile%2Fcdn%2F827037513%2F925948932%3FcontentType%3D0%26isNewContent%3Dfalse&attachmentId=925948932&name=%E7%94%B3%E6%8A%A5%E6%9C%BA%E6%9E%84%E4%BF%A1%E6%81%AF%E5%AF%B9%E5%BA%94%E5%A1%AB%E5%86%99%E4%BF%A1%E6%81%AF.xlsx
export const OrgInfos = [
  // part-base基础信息/buss经营信息
  // reqY必填的机构
  // reqN非必填的机构
  {
    key: OrgKs.creditCode,
    label: '统一社会信用代码',
    part: 'base',
    reqY: [0, 2, 3, 4, 5],
    reqN: [1],
  },
  {
    key: OrgKs.registeredCapital,
    label: '注册资金',
    part: 'base',
    reqY: [0],
    reqN: [2, 3, 4, 5],
  },
  {
    key: OrgKs.registerDate,
    label: '成立日期',
    part: 'base',
    reqY: [0, 2, 3, 4, 5],
    reqN: [],
  },
  {
    key: OrgKs.legalPerson,
    label: '法定代表人',
    part: 'base',
    reqY: [0, 2, 5],
    reqN: [1, 3, 4],
    maxLen: 20,
  },
  {
    key: OrgKs.lastYearTaking,
    label: '上一年营收',
    part: 'base',
    reqY: [0, 2, 3, 4, 5],
    reqN: [1],
  },
  {
    key: OrgKs.location,
    label: '机构地址',
    part: 'base',
    reqY: [0, 1, 2, 3, 4, 5],
    reqN: [],
    maxLen: 100,
  },
  {
    key: 'certification',
    label: '企业资质证书',
    part: 'base',
    reqY: [],
    reqN: [0, 2, 3, 4, 5],
  },
  {
    key: OrgKs.isMerge,
    label: '是否三证合一',
    part: 'base',
    reqY: [0, 2, 5],
    reqN: [],
  },
  {
    key: OrgKs.qualificationCertificate,
    label: '资质证书',
    part: 'base',
    reqY: [0, 2, 3, 4, 5],
    reqN: [],
  },
  {
    key: OrgKs.mainBusiness,
    label: '主营业务',
    part: 'buss',
    reqY: [0, 2],
    reqN: [1, 3, 4, 5],
    maxLen: 200,
  },
  {
    key: OrgKs.businessScope,
    label: '经营范围',
    part: 'buss',
    reqY: [0, 2],
    reqN: [1, 3, 4, 5],
    maxLen: 200,
  },
  {
    key: OrgKs.organizationAbstract,
    label: '机构简介',
    part: 'buss',
    reqY: [0, 2],
    reqN: [1, 3, 4, 5],
    maxLen: 500,
  },
];

export const cert = {
  type: 0, //0-三证合一，1-营业执照 2-组织机构代码证 3-税务登记证 4-事业单位法人证书/社会团体法人登记证书
  isLongEffective: 0, //0-否 1-是
  invalidDate: '',
  fileUrl: '',
};
export function getCert(code) {
  if (code === 1) {
    // 三证合一
    return [{ ...cert }];
  }
  if (code === 0) {
    return [
      { ...cert, type: 1 },
      { ...cert, type: 2 },
      { ...cert, type: 3 },
    ];
  }
  if (code === 3) {
    //事业单位
    return [{ ...cert, type: 4 }];
  }
  if (code === 4) {
    //社会团体
    return [{ ...cert, type: 4 }];
  }
}

export const cols = { field: { span: 9, offset: 0 }, label: { span: 3, offset: 0 } };
